import { FormBase } from 'core/components';

export default class NikoCreateNewPatientForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'firstName',
                    label: 'First Name',
                    placeholder: 'Enter First Name',
                    rules: 'required|string',
                },
                {
                    name: 'lastName',
                    label: 'Last Name',
                    placeholder: 'Enter Last Name',
                    rules: 'required|string',
                },
                {
                    name: 'nickname',
                    label: 'Nickname',
                    placeholder: 'Enter Nickname',
                    rules: 'string',
                },
                {
                    name: 'gender',
                    label: 'Gender',
                    placeholder: 'Select Gender',
                    rules: 'required',
                },
                {
                    name: 'dateOfBirth',
                    label: 'Date of Birth',
                    placeholder: 'MM/DD/YYYY',
                    value: new Date(new Date().setDate(new Date().getDate() - 1)),
                    rules: 'required|before_or_equal_date:' + new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0],
                },
                {
                    name: 'ssn',
                    label: 'Social Security Number',
                    placeholder: 'Enter SSN',
                    rules: 'string',
                },
                {
                    name: 'noSsn',
                    label: 'No SSN?',
                    type: 'checkbox',
                },
                {
                    name: 'insuranceStatusId',
                    label: 'Insurance Status',
                    placeholder: 'Select Status',
                    rules: 'required|string',
                },
                {
                    name: 'effectiveDate',
                    label: 'Effective Date',
                    placeholder: 'Select Date',
                },
                {
                    name: 'note',
                    label: 'Note',
                    placeholder: 'Enter Note',
                    rules: 'string',
                },
                {
                    name: 'insuranceQuestion',
                    label: 'Insurance Question',
                    placeholder: 'Enter Insurance Question',
                    rules: 'string',
                },
                {
                    name: 'insuranceInfoNote',
                    label: 'Insurance Info Note',
                    placeholder: 'Enter Insurance Info Note',
                    rules: 'string',
                },
                {
                    name: 'insuranceStatusNote',
                    label: 'Insurance Eligibility Status Note',
                    placeholder: 'Enter Eligibility Status Note',
                    rules: 'string',
                },
            ],
        };
    }
}
